/**
 * Labstep
 */

// eslint-disable-next-line no-shadow
export enum NodeKeys {
  protocol_step = 'protocol_step',
  experiment_step = 'experiment_step',
}
